module.exports = __webpack_public_path__ + "static/img/3_1_1.0f0d3ffd.jpg";